import React from 'react';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

export interface MenuItem {
  id: string;
  label: string;
  icon: string;
  path: string;
}

// Add HMO screens here as they land; Layout derives the active item from the
// current pathname, so a new entry only needs an id/label/icon/path.
export const menuItems: MenuItem[] = [
  { id: 'create-lead', label: 'יצירת הפנייה', icon: '📝', path: '/create-lead' },
  // Shown once the spec was settled (Shachar had asked on 01/09 for "what
  // exactly we show her, how we show it, the search" to be specced first).
  // Sits second on purpose: she opens a referral, then goes looking for it.
  { id: 'my-leads', label: 'ההפניות שלי', icon: '📄', path: '/my-leads' },
  { id: 'followup-approvals', label: 'אישורי המשך', icon: '📋', path: '/followup-approvals' },
  { id: 'profile', label: 'פרופיל', icon: '👤', path: '/profile' },
];

interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
  activeItem?: string;
  onNavigate?: (path: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  isCollapsed,
  onToggle,
  activeItem = 'create-lead',
  onNavigate,
}) => {
  return (
    <div
      style={{
        width: isCollapsed ? 60 : 200,
        backgroundColor: '#3A7380',
        height: 'calc(100vh - 60px)',
        position: 'fixed',
        left: 0,
        top: 60,
        transition: 'width 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 900,
        overflow: 'visible',
      }}
    >
      <button
        onClick={onToggle}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        style={{
          position: 'absolute',
          right: -16,
          top: 20,
          width: 32,
          height: 32,
          borderRadius: '50%',
          backgroundColor: '#3A7380',
          border: '2px solid #fff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          zIndex: 1,
          padding: 0,
          transition: 'all 0.3s ease',
        }}
      >
        {isCollapsed ? (
          <KeyboardArrowRight sx={{ fontSize: 20 }} />
        ) : (
          <KeyboardArrowLeft sx={{ fontSize: 20 }} />
        )}
      </button>

      <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', marginTop: 20 }}>
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate?.(item.path)}
            style={{
              width: '100%',
              padding: isCollapsed ? '16px 0' : '16px 20px',
              backgroundColor: activeItem === item.id ? 'rgba(255,255,255,0.1)' : 'transparent',
              border: 'none',
              borderLeft: activeItem === item.id ? '4px solid #fff' : '4px solid transparent',
              color: '#fff',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              fontSize: 14,
              fontWeight: 500,
              transition: 'all 0.2s',
              justifyContent: isCollapsed ? 'center' : 'flex-start',
              textAlign: 'left',
            }}
            onMouseEnter={(e) => {
              if (activeItem !== item.id) {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeItem !== item.id) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
          >
            <span style={{ fontSize: 18, display: 'inline-flex' }}>{item.icon}</span>
            {!isCollapsed && <span>{item.label}</span>}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
